import { AppLayout, getEntitlementCRMPriceInfo, State, useLayout, useTile } from "core";
import { Focusable } from "@blacknut/spatialnav-sdk/dist";
import * as React from "react";
import FadeInImage from "../FadeInImage/FadeInImage";
import { usePreview } from "../Modals/PreviewContext";
import styles from "./styles.module.scss";
import clsx from "clsx";
import {
  EntitlementCRMInfo,
  EntitlementKind,
  List,
  Page,
  Tile,
  getImageByOrientation,
  isValidEntitlement,
} from "@blacknut/javascript-sdk/dist";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as IcPassOverlay } from "../../assets/dist/ic_pass_overlay.svg";
import { useOrientation } from "src/utils/OrientationContext";
import { useEffect } from "react";
import { LOGGING_TAG } from "src/utils/Utils";
import { logE } from "@blacknut/logging/dist";
import { isTryBuy } from "src/utils/subscription";

interface V2BannerTileProps {
  item: Tile;
  list: List;
  className?: string;
  inView: boolean;
  page?: Page;
}

const BannerTile = ({
  item,
  list,
  className,
  inView = true,
  page,
}: V2BannerTileProps) => {
  const { crmInfo } = useSelector((state: State) => state.entitlementState);
  const dispatch = useDispatch();
  const { active: previewActive } = usePreview();
  const { config, subscription } = useSelector((state: State) => state.globalState);
  const { entitlements } = subscription;

  const blacknutPlus = !!config?.features?.blacknutplus;
  const isPassOnly =
    item.game?.addonOption?.inGamePass && !item.game?.addonOption?.isBonusGame;
  const isUnlocked =
    item.game?.addonOption?.userHasGamePass || item.game?.addonOption?.userHasBonusGame;

  const layout = useLayout();
  const { onClick } = useTile({
    item,
    previewMode: previewActive,
    pageUuid: page?.uuid,
  });
  const isMobile = layout === AppLayout.PHONE;
  const { orientation } = useOrientation();
  const imgBanner = getImageByOrientation(orientation, list.imgBackground ?? []);

  let entitlementCRMInfo: EntitlementCRMInfo | undefined;
  if (list.entitlement) {
    entitlementCRMInfo = crmInfo[list.entitlement];
  }

  useEffect(() => {
    const init = async () => {
      if (!entitlementCRMInfo && list.entitlement) {
        const main = entitlements.find((e) => e.kind === EntitlementKind.MAIN);

        try {
          await getEntitlementCRMPriceInfo({
            entitlementId: list.entitlement,
            bundle: !isValidEntitlement(main) || isTryBuy(main),
          })(dispatch);
        } catch (e) {
          logE(LOGGING_TAG, "Caught error getting entilement crm info: %o", e);
        }
      }
    };
    init();
  }, [dispatch, entitlementCRMInfo, entitlements, list.entitlement]);

  return (
    <Focusable
      className={clsx(styles.container, styles.focusable, className)}
      onClick={onClick}
      onPressEnter={onClick}
    >
      {inView && <FadeInImage image={imgBanner} className={styles.image} />}
      {blacknutPlus && isPassOnly && !isUnlocked && (
        <span
          className={clsx(styles.bonus, isMobile && styles.onMobileBonus)}
          data-testid="pass"
        >
          <IcPassOverlay />
        </span>
      )}
      {entitlementCRMInfo?.listText && (
        <div
          className={styles.priceText}
          dangerouslySetInnerHTML={{ __html: entitlementCRMInfo.listText }}
        />
      )}
    </Focusable>
  );
};

export default BannerTile;
